import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLines } from "./Reveal";

const PageHero = ({ eyebrow, lines, description, image, children, compact = false }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "28%"]);

  return (
    <section
      ref={ref}
      data-testid="page-hero"
      className={`relative flex items-end overflow-hidden bg-navy ${compact ? "min-h-[52vh] pt-36 pb-16" : "min-h-[68vh] pt-40 pb-24"}`}
    >
      <motion.div style={{ y: bgY }} className="absolute inset-0 scale-110">
        <img src={image} alt="" className="h-full w-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-navy/60" />
      </motion.div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 lg:px-10">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="inline-flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          <span className="h-px w-10 bg-gold" />
          {eyebrow}
        </motion.span>
        <h1 className="mt-6 max-w-4xl font-display text-5xl leading-[1.04] text-white sm:text-6xl lg:text-7xl">
          <MaskedLines lines={lines} delay={0.25} />
        </h1>
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.65 }}
            className="mt-7 max-w-2xl text-base leading-relaxed text-white/70 md:text-lg"
          >
            {description}
          </motion.p>
        )}
        {children && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.8 }}
          >
            {children}
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default PageHero;
